export default "__VITE_ASSET__8809b0ff__"